import { MouseEvent, useCallback } from 'react'
import { HistoryItemProps } from './HistoryItem.types'

/** Binds open/remove to this row, keeping the remove click off the row. */
export function useHistoryItemController({ item, onOpen, onRemove }: HistoryItemProps) {
  const onOpenClick = useCallback(() => onOpen(item.id), [item.id, onOpen])

  const onRemoveClick = useCallback(
    (event: MouseEvent<HTMLElement>) => {
      event.stopPropagation()
      onRemove(item.id)
    },
    [item.id, onRemove],
  )

  return { onOpenClick, onRemoveClick }
}
